import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { EditorState } from 'lexical';

export const RestoreStatePlugin = ({ editorState }: { editorState?: EditorState }) => {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        if (editorState && editor) {
            editor.setEditorState(editorState);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};

export default RestoreStatePlugin;
